/*
 * @Description: What's this for
 * @Autor: WangYuan
 * @Date: 2021-10-12 15:38:29
 * @LastEditors: WangYuan
 * @LastEditTime: 2021-11-12 17:15:26
 */
export default {
    "label": "标题修饰",
    "type": "selectTitleMode",
    "value": {
        "status": "left",
        "color": "",
        "url": "",
        "height": "",
        "zoom": "repeat"
    },
    "options": {
        "default": {
            "status": "left",
            "color": "",
            "url": "",
            "height": "",
            "zoom": "repeat"
        }
    }
}
